import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardDossierStatesDefinition } from '../create-dossier-states-definition';
import { DossierShell } from '../dossier-shell.profile';
import {
  DossierOverviewMetricProfile,
  dossierOverviewEconomicParticipantProfile,
  dossierOverviewEmployedProfile,
  dossierOverviewGvaProfile,
  dossierOverviewRevenueProfile,
  dossierOverviewTaxedProfile,
} from './dashboard-dossier-states-overview-metric.profile';
import { DashboardDossierStatesOverviewDefinition } from './dashboard-dossier-states-overview.definition';

/**
 * Product catalog for dossier states overview (marktstruktur).
 * Identity is derived in {@link createDashboardDossierStatesDefinition}.
 */

// Pending datasets: Tourism and SelfEmployed dossiers.
type DossierOverviewMetric = Exclude<Metric, Metric.Tourism | Metric.SelfEmployed>;

export const DOSSIER_STATES_OVERVIEW_PRODUCT_CATALOG: Record<
  DossierOverviewMetric,
  ProductCatalogEntry<DossierOverviewMetricProfile, DossierShell>
> = {
  [Metric.CompaniesCount]: {
    metric: dossierOverviewTaxedProfile,
    shells: ['overview'],
  },
  [Metric.CompaniesRevenue]: {
    metric: dossierOverviewRevenueProfile,
    shells: ['overview'],
  },
  [Metric.GrossValueAdded]: {
    metric: dossierOverviewGvaProfile,
    shells: ['overview'],
  },
  [Metric.EconomicParticipant]: {
    metric: dossierOverviewEconomicParticipantProfile,
    shells: ['overview'],
  },
  [Metric.Employed]: {
    metric: dossierOverviewEmployedProfile,
    shells: ['overview'],
  },
};

/** All dossier states overview (marktstruktur) product definitions. */
export const DOSSIER_STATES_OVERVIEW_DEFINITIONS: DashboardDossierStatesOverviewDefinition[] =
  expandProductCatalog(
    Object.values(DOSSIER_STATES_OVERVIEW_PRODUCT_CATALOG),
    createDashboardDossierStatesDefinition,
  ) as DashboardDossierStatesOverviewDefinition[];
